<template>
  <div class="animated fadeIn">
    <p>
      <!-- Exit -->
      初期設定後、いつでも設定を変更することができます。
      <b-button class="float-right" variant="link" @click="$parent.$emit('toggle', false)">Exitクイックガイド</b-button>
    </p>
    <b-card-group>
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <!-- 안내 및 설정 방법 -->
        <b-row>
          <b-col class="text-center">
            <h3>
              新しいエージェントをインストールしました！
            </h3>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" @click="list">
                <b-card-text>
                  <strong>
                    設定を別のサーバにコピーする
                  </strong>
                  <hr>
                  <p>そのサーバに他のWebファイアウォールの設定を適用する</p>
                  <hr>
                  <p>
                    エージェントを選択 → 他のサーバに適用 → 保存
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="info" @click="next()">
                <b-card-text>
                  <p style="font-size: 1.7rem;">
                    コンフィギュレーションポリシー
                  </p>
                  <hr>
                  <p style="font-size: 1.4rem;">検知ログ検証のための最小限のポリシーを適用する</p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInLeft slideOutLeft">
        <b-row class="text-center">
          <b-col>
            <h4 class="mt-2">* インストールしたサーバのレベルを選択する</h4>
            ステップによって、使用するポリシーの数、ポリシーによる検出、予防に違いがあります。
            <strong>クイックセットアップのためのステップで、ポリシーの最適化、例外処理などを追加することができます。</strong>
          </b-col>
        </b-row>
        <hr>
        <b-row class="">
          <b-col md="6">
            <VueApexCharts style="max-width:50%; margin: 0px auto;" type="pie" ref="_chart_policy" :options="info.chart.policy.option" :series="info.chart.policy.series" />
          </b-col>
          <b-col class="text-left">
            <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="0">
                テスト工程
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'A step for testing and testing the use of each policy Use it when proceeding with the PoC'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (すべて未使用、段階的に起動)

              </b-form-radio>

              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1">
                早期
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'この手順では、インストールおよびテスト モードで初めて使用するときにセットアップします。 OWASP TOP 10 などの一般的なポリシー検出に設定して、どのような種類の攻撃が入ってくるかを確認します。'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (OWASP TOP 10などのポリシー検出モード、除外ポリシーを除く)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="2">
                Block Mode
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'除外ポリシーを除くすべてのポリシーは検出モードに設定されます。ブロックする前の推奨ポリシー手順'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (除外ポリシーを除く、完全なポリシーのブロック設定)

              </b-form-radio>
              <!-- <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="0">
                Test Steps
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'各ポリシーの使用をテストおよびテストするためのステップ PoC を進めるときに使用します'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (すべて未使用、段階的アクティベーション)

              </b-form-radio>

              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1">
                早期
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'この手順では、インストールおよびテスト モードで初めて使用するときにセットアップします。 OWASP TOP 10 などの一般的なポリシー検出に設定して、どのような種類の攻撃が入ってくるかを確認します。'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (検知に重点を置いている)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1.5">
                初期拡張フェーズ
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'除外ポリシーを除くすべてのポリシーは検出モードに設定されます。ブロックする前の推奨ポリシー手順'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (OWASP TOP10、疑惑の攻撃を検出)

              </b-form-radio> -->
            </b-col>
            <!-- <b-col class="text-left">
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="2">
                中盤以降
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'一定期間の検出期間を運用した後、OWASP TOP 10などの基本的な攻撃をブロックするステップです'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (共通攻撃ブロック)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="3">
                 長期
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="`これは適切な検出とブロックが混在するステップです サイトが増えると誤試行も増える可能性があるため、ポリシーの最適化が必要です`">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (アドバンスドアタックを含めカットオフ)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="4">
                最終ステージ
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'これは、除外ポリシーを除き、ブロック操作を推奨するステップです。全体的な攻撃を防ぐためのステップとして、ポリシーの最適化が進んだ後に設定することを推奨します。'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (全ポリシーをブロック、進出をブロック、接続攻撃の疑いがあるものをブロック)
              </b-form-radio>
          </b-col> -->
        </b-row>
      </b-card>
      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">

      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <hr v-if="step < all">
    <b-button v-if="step > 1" block size="sm" variant="info" @click="prev()"> プレビュー </b-button>
    <b-button v-if="step < 2"  block size="sm" variant="primary" @click="next()">次へ </b-button>
    <b-button v-if="step == 2" class="btn-add"  block size="sm" variant="success" @click="modal_save = true">保存 </b-button>
    <hr>
    <b-row>
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="ポリシーをエージェントに適用(WAF)"  class="modal-success" v-model="modal_save" @ok="apply" ok-variant="success" header-bg-variant="warning">
      設定を適用しますか？
      <hr>
      適用後、クイックセットアップを再開することができます。
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
